export default __webpack_public_path__ + "static/media/insights.8545c5d0.svg";